// Re-export useSocket hook from SocketProvider for convenience
export { useSocket } from '../providers/SocketProvider'; 